<template>
  <el-dialog
    title="仪器编辑"
    :visible.sync="state"
    width="30%"
    :before-close="handleClose"
  >
    <!-- 内容 -->
    <tz-form
      width="110px"
      :formConfig="formConfig"
      :formBtns="formBtns"
      :row="user"
      @submit="submitFn"
    ></tz-form>
    <!-- 内容 -->
  </el-dialog>
</template>

<script>
export default {
  props: {
    state: {
      type: Boolean,
      default: false
    },
    user: Object,
    roles: Array
  },

  data() {
    return {
      // 表单配置
      formConfig: [
        {
          label: '仪器名称',
          field: 'toolname',
          type: 'text',
          rules: [{ required: true, message: '仪器名称必填', trigger: 'blur' }]
        },
        {
          label: '排序',
          field: 'px',
          type: 'text',
          rules: [{ required: true, message: '排序必填', trigger: 'blur' }]
        }
        // {
        //   label: '仪器代码',
        //   field: 'toolcode',
        //   type: 'text',
        //   rules: [
        //     { required: true, message: '仪器代码必填', trigger: 'blur' }
        //     // { min: 1, max: 5, message: '简写长度为1到5', trigger: 'blur' }
        //   ]
        // },
        // {
        //   label: '仪器型号',
        //   field: 'tooltype',
        //   type: 'text',
        //   rules: [{ required: true, message: '仪器型号必填', trigger: 'blur' }]
        // }
      ],

      formBtns: [
        {
          content: '更新',
          width: '185px',
          type: 'primary'
          // },
          // {
          //   content: '重置',
          //   type: ''
        }
      ]
    }
  },
  methods: {
    handleClose() {
      this.$emit('close')
    },
    submitFn(formData) {
      this.$emit('confirm', formData)
      console.log('更新数据处理', formData)
    }
  }
}
</script>

<style></style>
